import { compose } from 'redux';
import { IInternalCashierPaymentsProps } from '../../cashier-payments';
import { AdaptedComponentsTPA } from '../adapted-components/tpa';
import { CashierPaymentsWidgetRoot } from './root';
import { withAdaptedComponents } from './utils/withAdaptedComponents';
import { withStyles } from './utils/withStyles';
import { withTPAProvider } from './utils/withTPAProvider';

export const CashierPaymentsWidget = compose<
  React.FC<IInternalCashierPaymentsProps>
>(
  withAdaptedComponents<IInternalCashierPaymentsProps>(AdaptedComponentsTPA),
  withStyles,
  withTPAProvider
)(CashierPaymentsWidgetRoot);
